<template>
<blockquote v-html='content' class="blockquote "></blockquote>
</template>
<script>
export default {
props : {
    content : String
}
}
</script>